import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export enum BinNamingField {
  ROW = "ROW",
  RACK = "RACK",
  SHELF = "SHELF",
  BIN = "BIN",
}

export enum SEPARATOR {
  DASH = "-",
}

export const BinFieldUsedSchema = z.record(
  createEnum(BinNamingField),
  z.boolean(),
);

export const BinNamingSettingsSchema = z.object({
  binFieldUsed: BinFieldUsedSchema,
  separator: createEnum(SEPARATOR),
});
export type BinNamingSettings = z.infer<typeof BinNamingSettingsSchema>;
